---@meta

---@class DatetimeParts
---@field year integer
---@field month integer
---@field day integer
---@field hour integer
---@field min integer
---@field sec integer
---@field TZ number
---@field TZName string

---@class DurationTable
---@field years integer
---@field months integer
---@field days integer
---@field hours integer
---@field minutes integer
---@field seconds integer

---@class Datetime
---@field TZ number
---@field TZName string
---@field format fun(self: Datetime, format: string): string
---@field to_utc fun(self: Datetime): Datetime
---@field to_offset fun(self: Datetime, tz: string|number): Datetime, string
---@field add fun(self: Datetime, duration: DurationTable): Datetime
---@field sub fun(self: Datetime, duration: DurationTable): Datetime
---@field diff fun(self: Datetime, other: Datetime, detailed: boolean): number|table
---@field clone fun(self: Datetime): Datetime
---@field to_table fun(self: Datetime): DatetimeParts

---@class DatetimeLib
---@field now fun(tz: string|number): Datetime, string
---@field parse fun(value: string, format: string): Datetime, string
---@field from_timestamp fun(seconds: integer): Datetime
---@field timestamp fun(): number

datetime = {} ---@type DatetimeLib
